module.exports = __webpack_public_path__ + "static/media/professional-catering.f1022c12.jpg";